import { PropsWithChildren } from 'react'
import { cn } from '../../utils'
import { RouteLink } from './route-link'

interface Props {
  instation?: boolean
  href: Path
  strong?: boolean
}

export function TextLink({ href, className, strong, children }: PropsWithChildren<PropsWithClass<Props>>) {
  return (
    <RouteLink href={href} className={cn('text-secondary-primary', className)}>
      {strong ? <strong>{children}</strong> : children}
    </RouteLink>
  )
}
